// ==============================|| OVERRIDES - TABLE ROW ||============================== //
// material-ui
import { Theme } from "@mui/material/styles"

export default function TableRow(theme: Theme) {
    return {
        MuiTableRow: {
            styleOverrides: {
                root: {
                    "&:last-of-type": {
                        "& .MuiTableCell-root": {
                            borderBottom: "none",
                        },
                    },
                    "& .MuiTableCell-root": {
                        "&:last-of-type": {
                            paddingRight: 24,
                        },
                        "&:first-of-type": {
                            paddingLeft: 24,
                        },
                    },
                    "&.Mui-selected": {
                        backgroundColor: `${theme.palette.primary.lighter} !important`,
                    },
                },
            },
        },
    }
}
